<template>
  <div class="medic-form">
    <div class="breadcrumb">
      <i class="fa fa-home"></i> Estás en:
      <router-link :to="{name: 'medics'}">Médicos</router-link>/ Nuevo médico
    </div>
    <div class="wrapper-form clearfix">
      <div class="form-title">
        <div class="text-bold">
          <i class="fas fa-edit u-black-light"></i> Nuevo médico
        </div>
      </div>
      <div class="form-wrapper">
        <div class="form-group">
          <label class="form-label">Nombre del médico</label>
          <input class="form-input" v-model="medic.name" />
        </div>
        <div class="form-group">
          <label class="form-label">Wallet</label>
          <input class="form-input" v-model="medic.wallet" />
        </div>
<!-- 
        <div class="form-group">
          <label class="form-label"> Hospital</label>
          <input class="form-input" v-model="medic.center">
          </div> -->

        <button type="button" class="btn btn-primary float-right" v-on:click="deploy">Enviar</button>
      </div>
    </div>
  </div>
</template>


<script>
import MedicsManager from "../managers/medicsManager";
import Swal from "sweetalert2";
export default {
  components: {},
  data() {
    return {
      medic: {
        name: "",
        wallet: ""
      },
      files: []
    };
  },
  methods: {
    async deploy() {
      Swal.fire({
        title: "¿Estás seguro?",
        showCancelButton: true,
        confirmButtonText: "Sí",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return new Promise(resolve => {
            MedicsManager.CreateMedic(this.medic).then(() => {
              resolve(true);
            });
          });
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then(result => {
        if (result.value) {
          Swal.fire({
            title: `¡Creado!`
          });

          this.$router.push({ name: "medics" });
        }
      });
    }
  },
  async created() {}
};
</script>